/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  EmptyTreeInfo,
  GetActivityStatusTreeParams
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetActivityStatusTreeUrl = (params?: GetActivityStatusTreeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ActvityStatus/GetActivityStatusTree?${stringifiedParams}` : `/api/ActvityStatus/GetActivityStatusTree`
}

export const getActivityStatusTree = async (params?: GetActivityStatusTreeParams, options?: Parameters<typeof customInstance>[1]): Promise<EmptyTreeInfo> => {

  return customInstance<EmptyTreeInfo>(getGetActivityStatusTreeUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetActivityStatusTreeQueryKey = (params?: GetActivityStatusTreeParams,) => {
    return [
    `/api/ActvityStatus/GetActivityStatusTree`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetActivityStatusTreeQueryOptions = <TData = Awaited<ReturnType<typeof getActivityStatusTree>>, TError = ErrorType<unknown>>(params?: GetActivityStatusTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityStatusTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActivityStatusTreeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActivityStatusTree>>> = ({ signal }) => getActivityStatusTree(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActivityStatusTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetActivityStatusTreeQueryResult = NonNullable<Awaited<ReturnType<typeof getActivityStatusTree>>>
export type GetActivityStatusTreeQueryError = ErrorType<unknown>


export function useGetActivityStatusTree<TData = Awaited<ReturnType<typeof getActivityStatusTree>>, TError = ErrorType<unknown>>(
 params: undefined |  GetActivityStatusTreeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityStatusTree>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivityStatusTree>>,
          TError,
          Awaited<ReturnType<typeof getActivityStatusTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivityStatusTree<TData = Awaited<ReturnType<typeof getActivityStatusTree>>, TError = ErrorType<unknown>>(
 params?: GetActivityStatusTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityStatusTree>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivityStatusTree>>,
          TError,
          Awaited<ReturnType<typeof getActivityStatusTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivityStatusTree<TData = Awaited<ReturnType<typeof getActivityStatusTree>>, TError = ErrorType<unknown>>(
 params?: GetActivityStatusTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityStatusTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetActivityStatusTree<TData = Awaited<ReturnType<typeof getActivityStatusTree>>, TError = ErrorType<unknown>>(
 params?: GetActivityStatusTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityStatusTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActivityStatusTreeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetActivityStatusTreeSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getActivityStatusTree>>, TError = ErrorType<unknown>>(params?: GetActivityStatusTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivityStatusTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActivityStatusTreeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActivityStatusTree>>> = ({ signal }) => getActivityStatusTree(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivityStatusTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetActivityStatusTreeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getActivityStatusTree>>>
export type GetActivityStatusTreeSuspenseQueryError = ErrorType<unknown>


export function useGetActivityStatusTreeSuspense<TData = Awaited<ReturnType<typeof getActivityStatusTree>>, TError = ErrorType<unknown>>(
 params: undefined |  GetActivityStatusTreeParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivityStatusTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivityStatusTreeSuspense<TData = Awaited<ReturnType<typeof getActivityStatusTree>>, TError = ErrorType<unknown>>(
 params?: GetActivityStatusTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivityStatusTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivityStatusTreeSuspense<TData = Awaited<ReturnType<typeof getActivityStatusTree>>, TError = ErrorType<unknown>>(
 params?: GetActivityStatusTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivityStatusTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetActivityStatusTreeSuspense<TData = Awaited<ReturnType<typeof getActivityStatusTree>>, TError = ErrorType<unknown>>(
 params?: GetActivityStatusTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivityStatusTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActivityStatusTreeSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






